import { useQuery } from "@tanstack/react-query";
import { agencyTagQueries, sessionQueries } from "../queries";
import { CommonAPI } from "../types";
import { Toolbar } from "@bagel-web/components";
import AgencyTagSelect from "../tag/AgencyTagSelect";
import { AgencyTagFilter } from "../tag/AgencyTagFilter";

const AgentHistoryFilterBar = ({
  organization,
  sessionId,
  commonAPI,
  agencyTagFilter,
  onChange,
}: {
  organization: string;
  sessionId: string;
  commonAPI: CommonAPI;
  agencyTagFilter: AgencyTagFilter;
  onChange: (agencyTagFilter: AgencyTagFilter) => void;
}) => {
  const { data: session, isPending: sessionPending } = useQuery({
    queryKey: sessionQueries.get(sessionId),
    queryFn: () => commonAPI.fetchSession(sessionId),
  });

  const { data: agencyTags, isPending: agencyTagsPending } = useQuery({
    queryKey: agencyTagQueries.list(organization, session?.project_id || ""),
    queryFn: () =>
      commonAPI.fetchProjectAgencyTags({
        organization,
        projectId: session?.project_id || "",
      }),
    enabled: !!session?.project_id,
  });

  return (
    agencyTags?.items &&
    agencyTags.items.length > 0 && (
      <Toolbar $justifyContent="flex-end">
        <AgencyTagSelect
          disabled={sessionPending || agencyTagsPending}
          agencyTags={agencyTags?.items || []}
          value={agencyTagFilter}
          onChange={(e) => {
            onChange(e.target.value);
          }}
        />
      </Toolbar>
    )
  );
};

export default AgentHistoryFilterBar;
